function handleCartEvents(event) {
    console.log(event.type, event.detail); 

    setTimeout(() => {
        const button = document.querySelector(".btn-continue");
        if (button && !button.dataset.eventAdded) {
            button.addEventListener("click", () => {
                window.location.href = "https://blop.today/products/blop";
            });
            button.dataset.eventAdded = "true"; 
        }
    }, 500); // Trì hoãn 500ms (có thể điều chỉnh)
}

window.addEventListener('OpusCartChange', handleCartEvents);
window.addEventListener('OpusOpenCartState', handleCartEvents);
